import React, { useRef, forwardRef } from 'react';

import { Label, Input } from './styled';

const InputComponent = forwardRef(({
  contentWidth = '100%',
  labelText,
  style,
  children,
  ...props
}, ref) => {
  const _label = useRef(null);
  const _className = useRef('');

  function focus(e) {
    // props?.onFocus?.(e);

    if (_label.current) {
      const className = _label.current.className;
      _className.current = className;
      _label.current.className = `${className} input-focus`;
    }
  }

  function blur(e) {
    // props?.onBlur?.(e);

    if (_label.current) {
      _label.current.className = _className.current;
      _className.current = '';
    }
  }

  return (
    <Label
      ref={_label}
      contentWidth={contentWidth}
      style={style}
      isDisabled={props?.disabled}
    >
      <Input
        {...props}
        ref={ref}
        autoComplete="off"
        onFocus={focus}
        onBlur={blur}
      />
      {children}
    </Label>
  );
});

export default InputComponent;
